module.exports = __webpack_public_path__ + "static/media/warning-yellow-tri.2e875d9c.svg";